module.exports = __webpack_public_path__ + "static/media/hero-test-small.4dd25f70.jpg";